import { render, staticRenderFns } from "./announce_signed_contract_ru.vue?vue&type=template&id=1c5ac8e2&"
import script from "./announce_signed_contract_ru.vue?vue&type=script&lang=js&"
export * from "./announce_signed_contract_ru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports